import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import {bookingFormCommon} from './c005-bookingform-common';

export class mhUpgradeForm {
	private $mhUpgradeError:Array<string> = [];
	private bcommon = new bookingFormCommon();

	$scope: any = $('#mhupgrade-in--container');
	$scopeMob: any = $('#mob-mhupgrade--container');

	nav(): void {
		let _self = this;
		let $mabHeader:any = $('#mab-header');
		let bcommon = _self.bcommon;

		let $bookFlight: any = $('#book-flight--container');
		let $checkIn: any = $('#check-in--container');
		let $viewBooking: any = $('#view-booking--container');
		let $flightStatus: any = $('#flight-status--container');
		let $mhStay: any = $('#ibe-stay--container');
		let $login: any = $('#login-container');
		let $loggedin:any = $('#logged-in-user-menu');

		let $bookFlightMob: any = $('#mobile-bookflight--container');
		let $checkInMob: any = $('#mob-checkin--container');
		let $viewBookingMob: any = $('#mob-viewbooking--container');
		let $flightStatusMob: any = $('#mob-flightstatus--container');
		let $mhStayMob: any = $('#mob-stay--container');
		let $loginMob: any = $('#mob-login--container');
		let $loggedinMob: any = $('#mob-logged-in-user-menu');
		let $mhHolidays : any = $('#mholiday-ibe--container');  
		let $mobMholidays  : any = $('#mobile-mholidays--container');

		let $ibeNav: any;
		if($('.ibe-refresh').length >0) {
			$ibeNav = $('.desktop #bookingNav');
		}
		else {
			$ibeNav = $('#bookingNav');
		}
		let $ibeNavList: any = $('#bookingNav li');
		let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');

		let $bannerHeight: any = $('.img-holder').height();
		let $navOverlay: any = $('.mab-nav--overlay');

		// IBE Navigation show/hide Check in container
		$ibeNav.find('.mhupgrade').on('click', () =>{
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.mhupgrade').parent().addClass('selected');
			_self.$scope.show();
			$bookFlight.hide();
			$checkIn.hide()
			$viewBooking.hide();
			$flightStatus.hide();
			$mhStay.hide();
			$login.hide();
			$mhHolidays.hide();
			$loggedin.addClass('hidden');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
		});


		// Overlay container - IBE Navigation show/hide Mobile Check in container
		$navOverlay.find('.mobile-mhupgrade').on('click', () =>{
			$ibeNavList.removeClass('selected');
			$navOverlay.find('.mobile-mhupgrade').parent().addClass('selected');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mhStayMob.hide();
			$mobMholidays.hide();
			bcommon.scrollToTopIBE();

			if(window.innerWidth > 767 && window.innerWidth<1200){
				
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.mhupgrade').parent().addClass('selected');
			_self.$scope.show();
			$bookFlight.hide();
			$checkIn.hide()
			$viewBooking.hide();
			$flightStatus.hide();
			$mhStay.hide();
			$login.hide();
			$mhHolidays.hide();
			$loggedin.addClass('hidden');
			_self.$scopeMob.show();
			$bookFlightMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$mhStayMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
		}
		});
	}

	// MH Upgrade IBE - Booking Reference no.
	mhUpgradeSubmit(): void {
		let _self = this;

		let $mhUpgradeErrorValidation: any = $('.mhupgrade-error---validation');
		let $mhUpgradeSubmitBtn: any = $('.mhUpgradeSubmit');
		let $mhUpgradeRefNo: any = $('.airline-book--refno');
		let $mhUpgradeLastName: any = $('.mhupgrade-lastname');
		let $mhUpgradeRefValidator : any = $('.mhupgrade-validator');

		//Check-in Booking reference Submit Button
		$mhUpgradeSubmitBtn.click((evt:any) => {
			let _self = this;
			evt.preventDefault();
			this.$mhUpgradeError = [];
			$mhUpgradeErrorValidation.show();
			if(($mhUpgradeRefNo.val() != '') || ($mhUpgradeLastName.val() != '')){
				 $mhUpgradeErrorValidation.hide();
			}

			if($mhUpgradeRefNo.val() == ''){
				$mhUpgradeRefNo.addClass('has-error');
				$mhUpgradeRefNo.parent().find('.booking-form--title').addClass('has-error');
				let $mhUpgradeRefNoValidate:any = $mhUpgradeRefNo.attr('data-airlineno');
				this.$mhUpgradeError.push($mhUpgradeRefNoValidate);
			} else{
				$mhUpgradeRefNo.removeClass('has-error');
				$mhUpgradeRefNo.parent().find('.booking-form--title').removeClass('has-error');
			}

			if($mhUpgradeLastName.val() == ''){
				$mhUpgradeLastName.addClass('has-error');
				$mhUpgradeLastName.parent().find('.booking-form--title').addClass('has-error');
				let $mhUpgradeLastNameValidate:any = $mhUpgradeLastName.attr('data-lastname');
				this.$mhUpgradeError.push($mhUpgradeLastNameValidate);
			} else{
				$mhUpgradeLastName.removeClass('has-error');
				$mhUpgradeLastName.parent().find('.booking-form--title').removeClass('has-error');
			}

			$mhUpgradeRefValidator.text(this.$mhUpgradeError.join(', '));
			if((($mhUpgradeRefNo.val() != '') || $mhUpgradeLastName.val() != '')){
				console.log('Success');
			} else {
				console.log('Fail');
			}
		});
	}

	init3rdPartyScript():void {
		let _self = this;
		let prodUrl:string = "";
		let stageUrl:string =  "";
		let scriptUrl:string = _self.$scope.attr('data-script-url');

		if (window.location.hostname.indexOf('stage62') > -1 || window.location.hostname.indexOf('localhost') > -1) {
			// stage url
			scriptUrl = "https://upgrade-stage.plusgrade.com/offer/X0h51BMH/eligibility/lookup.js";
		} else {
			// prod url
			scriptUrl = "https://upgrade.plusgrade.com/offer/X0h51BMH/eligibility/lookup.js";
		}

		let scriptEl:any = document.createElement('script');
		scriptEl.setAttribute('src', scriptUrl);
		scriptEl.setAttribute('defer', 'defer');
		document.body.appendChild(scriptEl);
	}

	copyValueToInput(): void {
		let $mhUpdgradeLastname: any = $('.mhupgrade-lastname');
		let $mhUpdgradePNR: any = $('.mhupgrade-PNR');
		let $mhUpdgradeLastnameLabel: any = $('.mhUpgradeLastName label');
		let $mhUpdgradeLastnameInput: any = $('.mhUpgradeLastName input');
		let $mhUpgradePNRLabel: any = $('.AirlineBookingPNR label');
		let $mhUpdgradePNRInput: any = $('.AirlineBookingPNR input');

		$('.mhupgrade-lastname.page-value').change(function() {
				$mhUpdgradeLastname.val($(this).val());
				$mhUpdgradeLastnameLabel.addClass('input-filled');
				$mhUpdgradeLastnameInput.addClass('input-focused');
		});
		$('.mhupgrade-PNR.page-value').change(function() {
				$mhUpdgradePNR.val($(this).val());
				$mhUpgradePNRLabel.addClass('input-filled');
				$mhUpdgradePNRInput.addClass('input-focused');
		});

		 $('.mhupgrade-lastname.mob-page--value').change(function() {
				$mhUpdgradeLastname.val($(this).val());
				$mhUpdgradeLastnameLabel.addClass('input-filled');
				$mhUpdgradeLastnameInput.addClass('input-focused');
		});
		$('.mhupgrade-PNR.mob-page--value').change(function() {
				$mhUpdgradePNR.val($(this).val());
				$mhUpgradePNRLabel.addClass('input-filled');
				$mhUpdgradePNRInput.addClass('input-focused');
		});
	}

	/**
	 * pre-populate ibe on load with data attached via data-attributes
	 * for both desktop and mobile ibe
	 * @author dominic <dominic.gan@mirumagency.com>
	 *
	 * @param {ibeMHUpgradeData} data
	 * @param {any}         instance
	 */
	populateOnload(data:ibeMHUpgradeData, instance:any): void {
		console.log('pop mhu', data, instance);

		// populate desktop & mobile ibe
		// same field classnames so same method is okay

		// booking ref
		if (data.bookRef !== undefined) {
			let bookRefInput = instance.find('.mhupgrade-PNR');
			bookRefInput.val(decodeURI(data.bookRef)).blur();
		}

		// last name
		if (data.lastName !== undefined) {
			let lastNameInput = instance.find('.mhupgrade-lastname');
			lastNameInput.val(decodeURI(data.lastName)).blur();
		}
	}

	/**
	 * parse url params to detect mhupgrade deep link
	 * open and populate with params
	 * ?ibe=mhu&bookRef=ABC&lastName=ABC
	 */
	deeplink(): void {
		let _self = this;
		let bcommon = _self.bcommon;

		let urlParams = bcommon.getUrlVars(window.location.href);

		if (urlParams.ibe && urlParams.ibe === 'mhu') {

			// parse url params into ibeMHUpgradeData object
			let mhuData: ibeMHUpgradeData = {};

			mhuData.bookRef = urlParams.bookRef;
			mhuData.lastName = urlParams.lastName;

			let $scopeViewBooking: any = $('#view-booking--container');
			let $scopeViewBookingMob: any = $('#mob-viewbooking--container');
			const topNavIbe = $('.desktop#mab-bookingnav #view-booking--container');
			const mobNavIbe = $('.mobile#mab-bookingnav #mob-viewbooking--container');

			// expand desktop ibe
			if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
				let $ibeNav: any;
				if($('.ibe-refresh').length >0) {
					$ibeNav = $('.desktop #bookingNav');
				}
				else {
					$ibeNav = $('#bookingNav');
				}
				$ibeNav.find('.view-booking').trigger('click');
				let bookOptMHupgTab = $scopeViewBooking.find('.book-opt-mhupgrade');
				bookOptMHupgTab.trigger('click');
				_self.populateOnload(mhuData, topNavIbe);
			} else {
				let $mobIbeNav: any = $('#mab-bookingnav.mobile #bookingNav');
				$mobIbeNav.find('.mobile-view-booking').click();
				let mobbookOptMHupgTab = $scopeViewBookingMob.find('.book-opt-mhupgrade');
				mobbookOptMHupgTab.click();
				_self.populateOnload(mhuData, mobNavIbe);
			}
		}
	}
}

let scope:Element = document.querySelector('#mhupgrade-in--container');
if (scope){
	try {
		let mhupgradeform = new mhUpgradeForm();
		mhupgradeform.nav();
		mhupgradeform.copyValueToInput();
		$(document).ready(function(){
		//	mhupgradeform.init3rdPartyScript();
			//mhupgradeform.deeplink();
		});
	} catch(e) {console.error(e);}
}
